import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemSearchFilter, ItemSearchOptionField } from 'src/app/components/filter-list/models/filterClasses';
import { ComponentIds } from 'src/app/models/component-ids';
import { FilterBuilderOutput, FilterBuilderParam } from 'src/app/models/filter-builder';
import { ColumnOption } from 'src/app/models/grid-settings';

@Component({
  selector: 'app-reports-table-header',
  templateUrl: './reports-table-header.component.html',
  styleUrls: ['./reports-table-header.component.css'],
  standalone: false
})
export class ReportsTableHeaderComponent {

  // Added by Vipul on 18-02-2026 for scheduled exports dropdown
  @Input() id: string;
  @Input() title: string;
  @Input() params: FilterBuilderParam[];
  @Input() currentFilters: FilterBuilderOutput | ItemSearchOptionField[];
  @Input() staticFilters: ItemSearchOptionField[] | ItemSearchFilter;
  @Input() currentColumnOptions: ColumnOption[];
  // @Input() isEditorVisible: boolean;

  // Added by Vipul on 18-02-2026 for scheduled exports dropdown
  @Output() exportExcel = new EventEmitter<void>();
  @Output() exportCsv = new EventEmitter<void>();
  // @Output() showScheduledExportsEditorChange = new EventEmitter<boolean>();


  scheduledExportsDropdown = {
    placeholder: 'SCHEDULED EXPORTS',
    options: [
      // { label: 'View Scheduled Exports', value: 'view' },
      { label: 'Create New', value: 'create' }
    ],
    style: {
      width: '180px'
    }
  };

  exportsDropdown = {
    placeholder: 'EXPORTS',
    actionMode: true,
    options: [
      { label: 'Excel Format (.xlsx)', value: 'excel' },
      { label: 'CSV Format (.csv)', value: 'csv' }
    ],
    style: {
      width: '180px'
    }
  };

  constructor(
    public router: Router,
    public route: ActivatedRoute
  ) {}

  // handleEditorVisibility(value: boolean) {
  //   this.showScheduledExportsEditorChange.emit(value);
  // }

  onExportAction(type: string): void {
    switch (type) {
      case 'csv':
        this.exportCsv.emit();
        break;
      case 'excel':
        this.exportExcel.emit();
        break;
    }
  }

  onExportExcel(): void {
    this.exportExcel.emit();
  }

  onExportCsv(): void {
    this.exportCsv.emit();
  }
}
